import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/crew")({
  staticData: { title: "Crew" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/crew/page.tsx"),
    "CrewPage",
  ),
})
